// inv/src/pages/payment/ThankYouPage.jsx
import { useLocation, Navigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const ThankYouPage = () => {
  const { t } = useTranslation();
  const { state } = useLocation() || {};
  const [data] = useState(() => {
    if (state) return state;
    const raw = sessionStorage.getItem('ty-payload');
    return raw ? JSON.parse(raw) : null;
  });

  if (!data) return <Navigate to="/pricing" replace />;

  useEffect(() => {
    sessionStorage.removeItem('ty-payload');
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  const {
    planName = 'your new plan',
    immediate = null,
    credit = 0,
    currency = 'USD',
    nextBilledAt = null,
    downgrade = false,
  } = data;

  return (
    <div className="flex flex-col items-center justify-center h-[80vh] font-sans">
      <div className="bg-white shadow-lg rounded-xl p-10 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold mb-4">Thank you! 🎉</h1>

        <p className="text-gray-700 mb-6">
          Your switch to&nbsp;<b>{planName}</b>&nbsp;is complete.
          {downgrade && (
            <p className="text-gray-600 mb-6">
              {nextBilledAt
                ? t(
                  'pagePricing.content.other.downgradeMessage',
                  'You will keep paid features until {{date}}, then your account will switch to Free.',
                  {
                    date: new Date(nextBilledAt).toLocaleDateString(undefined, {
                      year: 'numeric', month: 'long', day: 'numeric',
                    }),
                  },
                )
                : t(
                  'pagePricing.content.other.downgradeNoDate',
                  'Your paid subscription has been cancelled and will revert to Free at the end of the current period.',
                )}
            </p>
          )}
        </p>

        {immediate !== null && (
          <p className="text-gray-600 mb-2">
            {immediate > 0 && (
              <>
                We just charged&nbsp;<b>{immediate.toFixed(2)} {currency}</b>
                {credit > 0 && (
                  <>
                    &nbsp;after applying&nbsp;
                    <b>{credit.toFixed(2)} {currency}</b>&nbsp;credit
                  </>
                )}
                .
              </>
            )}

            {immediate === 0 && credit > 0 && (
              <>
                We applied your credit of&nbsp;
                <b>{credit.toFixed(2)} {currency}</b>; no charge today.
              </>
            )}

            {immediate === 0 && credit === 0 && <>No charge was made today.</>}
          </p>
        )}

        {nextBilledAt && !downgrade && (
          <p className="text-gray-600 mb-6">
            Next payment on&nbsp;
            {new Date(nextBilledAt).toLocaleDateString(undefined, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
            .
          </p>
        )}

        <Link
          to="/app"
          className="inline-block bg-stone-800 hover:bg-stone-700 text-white px-5 py-2.5 rounded-md"
        >
          Go to my workspace
        </Link>
      </div>
    </div>
  );
};

export default ThankYouPage;